import { render, staticRenderFns } from "./HelpModal.vue?vue&type=template&id=0804b71a&scoped=true&"
import script from "./HelpModal.vue?vue&type=script&lang=ts&"
export * from "./HelpModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0804b71a",
  null
  
)

export default component.exports